import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SupportIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333Zm4.973 4.747-1.853.767a3.321 3.321 0 0 0-1.967-1.96l.767-1.854a5.308 5.308 0 0 1 3.053 3.047ZM8 10c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2ZM6.087 3.027l.78 1.853A3.334 3.334 0 0 0 4.88 6.86l-1.853-.773a5.323 5.323 0 0 1 3.06-3.06Zm-3.06 6.886 1.853-.766c.34.92 1.06 1.64 1.98 1.973l-.78 1.853a5.33 5.33 0 0 1-3.053-3.06Zm6.893 3.06-.767-1.853a3.319 3.319 0 0 0 1.967-1.98l1.853.78a5.338 5.338 0 0 1-3.053 3.053Z" />
  </Icon>
);

export default memo(SupportIcon);
